// extracted by mini-css-extract-plugin
export var quantityInput = "_oj-0";